export const emptyFunc = (): void => undefined;
export const emptyAsyncFunc = async (): Promise<void> => new Promise(resolve => resolve());
export const emptyArray: any = Object.freeze([]);
export const emptyObject = Object.freeze({});
